// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-item[data-v-359dca75] {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 66px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: var(--content-container-bgcolor);
}
.list-item.active[data-v-359dca75] {
  background-color: var(--list-item-activebgcolor);
}
.list-item.link[data-v-359dca75]:not(.no-hover) {
  cursor: pointer;
}
.list-item[data-v-359dca75]:not(.no-hover):hover {
  background-color: var(--list-item-bghover);
}
.list-item:not(:last-child) .item-content[data-v-359dca75]::after {
  content: ' ';
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1px;
  border-bottom: 1px solid var(--message-bg-color2);
}
.list-item.restrict-width .item-content .item-text[data-v-359dca75] {
  max-width: 78%;
}
.list-item.restrict-width .item-content .item-text .item-title[data-v-359dca75] {
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-item.version .item-content .item-text .item-title[data-v-359dca75] {
  max-width: 90%;
}
.list-item.history span[data-v-359dca75] {
  white-space: break-spaces !important;
}
.list-item .item-media[data-v-359dca75],
.list-item .item-text[data-v-359dca75],
.list-item .item-after[data-v-359dca75],
.list-item .item-link[data-v-359dca75] {
  margin: auto 0;
}
.list-item .item-media[data-v-359dca75]:first-child,
.list-item .item-text[data-v-359dca75]:first-child,
.list-item .item-after[data-v-359dca75]:first-child,
.list-item .item-link[data-v-359dca75]:first-child {
  margin-left: 15px;
}
.list-item .item-media[data-v-359dca75]:last-child,
.list-item .item-text[data-v-359dca75]:last-child,
.list-item .item-after[data-v-359dca75]:last-child,
.list-item .item-link[data-v-359dca75]:last-child {
  margin-right: 15px;
}
.list-item .item-content[data-v-359dca75] {
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1 1;
  overflow: hidden;
  justify-content: space-between;
}
.list-item .item-content .item-text[data-v-359dca75] {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
}
.list-item .item-content .item-text .item-title[data-v-359dca75],
.list-item .item-content .item-text .item-header[data-v-359dca75],
.list-item .item-content .item-text .item-footer[data-v-359dca75] {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.list-item .item-content .item-text .item-title[data-v-359dca75] {
  font-size: var(--titleFontSize);
  line-height: 1.2em;
  white-space: nowrap;
}
.list-item .item-content .item-text .item-header[data-v-359dca75],
.list-item .item-content .item-text .item-footer[data-v-359dca75] {
  font-size: var(--subTitleFontSize);
  color: var(--listitem-headerfooter-color);
}
.list-item .item-content .item-text .htswrapper[data-v-359dca75] {
  white-space: break-spaces;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 184px;
}
.list-item .item-content .item-after[data-v-359dca75] {
  color: var(--listitem-headerfooter-color);
}
.list-item .item-content .item-link[data-v-359dca75] {
  margin-left: 15px;
  font-size: 24px;
  color: var(--placeholder-color);
}
.list-item .item-content .item-link i[data-v-359dca75] {
  transform: translate(0, 6%);
}
.list-item .item-content .item-link .fa-times[data-v-359dca75] {
  font-weight: 100;
  font-size: 19px;
}
.list-item .item-content[data-v-359dca75] .highlighted {
  background-color: var(--highlighted-bgcolor);
  color: var(--bg-color);
  font-weight: 600;
}
.list-item .item-content .highlightend[data-v-359dca75] {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-item.compact[data-v-359dca75] {
  min-height: 55px;
  height: initial;
  padding: 0 20px;
  margin-bottom: 0;
  margin-top: -1px;
}
.list-item.compact[data-v-359dca75]:hover {
  background-color: var(--list-item-bghover);
}
.list-item.compact .item-text[data-v-359dca75] {
  margin: auto 0;
  padding: 10px 0;
}
.list-item.compact .item-text .item-header[data-v-359dca75] {
  font-size: 12px;
  color: gray;
}
.list-item.compact .item-text .item-title[data-v-359dca75] {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/ListItem.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,kDAAkD;AACpD;AACA;EACE,gDAAgD;AAClD;AACA;EACE,eAAe;AACjB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,iDAAiD;AACnD;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;;;;EAIE,cAAc;AAChB;AACA;;;;EAIE,iBAAiB;AACnB;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,eAAe;AACjB;AACA;;;EAGE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kCAAkC;EAClC,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;AACjB","sourcesContent":[".list-item[data-v-359dca75] {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  height: 66px;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: var(--content-container-bgcolor);\n}\n.list-item.active[data-v-359dca75] {\n  background-color: var(--list-item-activebgcolor);\n}\n.list-item.link[data-v-359dca75]:not(.no-hover) {\n  cursor: pointer;\n}\n.list-item[data-v-359dca75]:not(.no-hover):hover {\n  background-color: var(--list-item-bghover);\n}\n.list-item:not(:last-child) .item-content[data-v-359dca75]::after {\n  content: ' ';\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 1px;\n  border-bottom: 1px solid var(--message-bg-color2);\n}\n.list-item.restrict-width .item-content .item-text[data-v-359dca75] {\n  max-width: 78%;\n}\n.list-item.restrict-width .item-content .item-text .item-title[data-v-359dca75] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.list-item.version .item-content .item-text .item-title[data-v-359dca75] {\n  max-width: 90%;\n}\n.list-item.history span[data-v-359dca75] {\n  white-space: break-spaces !important;\n}\n.list-item .item-media[data-v-359dca75],\n.list-item .item-text[data-v-359dca75],\n.list-item .item-after[data-v-359dca75],\n.list-item .item-link[data-v-359dca75] {\n  margin: auto 0;\n}\n.list-item .item-media[data-v-359dca75]:first-child,\n.list-item .item-text[data-v-359dca75]:first-child,\n.list-item .item-after[data-v-359dca75]:first-child,\n.list-item .item-link[data-v-359dca75]:first-child {\n  margin-left: 15px;\n}\n.list-item .item-media[data-v-359dca75]:last-child,\n.list-item .item-text[data-v-359dca75]:last-child,\n.list-item .item-after[data-v-359dca75]:last-child,\n.list-item .item-link[data-v-359dca75]:last-child {\n  margin-right: 15px;\n}\n.list-item .item-content[data-v-359dca75] {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex: 1 1;\n  overflow: hidden;\n  justify-content: space-between;\n}\n.list-item .item-content .item-text[data-v-359dca75] {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-width: 100%;\n}\n.list-item .item-content .item-text .item-title[data-v-359dca75],\n.list-item .item-content .item-text .item-header[data-v-359dca75],\n.list-item .item-content .item-text .item-footer[data-v-359dca75] {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.list-item .item-content .item-text .item-title[data-v-359dca75] {\n  font-size: var(--titleFontSize);\n  line-height: 1.2em;\n  white-space: nowrap;\n}\n.list-item .item-content .item-text .item-header[data-v-359dca75],\n.list-item .item-content .item-text .item-footer[data-v-359dca75] {\n  font-size: var(--subTitleFontSize);\n  color: var(--listitem-headerfooter-color);\n}\n.list-item .item-content .item-text .htswrapper[data-v-359dca75] {\n  white-space: break-spaces;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 184px;\n}\n.list-item .item-content .item-after[data-v-359dca75] {\n  color: var(--listitem-headerfooter-color);\n}\n.list-item .item-content .item-link[data-v-359dca75] {\n  margin-left: 15px;\n  font-size: 24px;\n  color: var(--placeholder-color);\n}\n.list-item .item-content .item-link i[data-v-359dca75] {\n  transform: translate(0, 6%);\n}\n.list-item .item-content .item-link .fa-times[data-v-359dca75] {\n  font-weight: 100;\n  font-size: 19px;\n}\n.list-item .item-content[data-v-359dca75] .highlighted {\n  background-color: var(--highlighted-bgcolor);\n  color: var(--bg-color);\n  font-weight: 600;\n}\n.list-item .item-content .highlightend[data-v-359dca75] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.list-item.compact[data-v-359dca75] {\n  min-height: 55px;\n  height: initial;\n  padding: 0 20px;\n  margin-bottom: 0;\n  margin-top: -1px;\n}\n.list-item.compact[data-v-359dca75]:hover {\n  background-color: var(--list-item-bghover);\n}\n.list-item.compact .item-text[data-v-359dca75] {\n  margin: auto 0;\n  padding: 10px 0;\n}\n.list-item.compact .item-text .item-header[data-v-359dca75] {\n  font-size: 12px;\n  color: gray;\n}\n.list-item.compact .item-text .item-title[data-v-359dca75] {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
